
















import Vue from 'vue'

interface Data {
  isAnimateStart: boolean
  isAnimateComplete: boolean
}

interface Methods {
  handleAnimateStart: () => void
  handleAnimateComplete: () => void
}

interface Computed {
  isShowHeight: boolean
  isHiddenContent: boolean
  collapseHeight: number
}

interface Props {
  isCollapsed: boolean
  isDynamicDrawContent: boolean
}

export default Vue.extend<Data, Methods, Computed, Props>({
  data() {
    return {
      isAnimateStart: false,
      isAnimateComplete: true,
      isBeforeClose: false,
    }
  },
  props: {
    isCollapsed: {
      default: true,
    },
    isDynamicDrawContent: {
      default: false,
    },
  },
  methods: {
    handleAnimateStart(): void {
      this.isAnimateStart = true
      this.isAnimateComplete = false
    },
    handleAnimateComplete(): void {
      this.isAnimateStart = false
      this.isAnimateComplete = true
    },
  },
  computed: {
    isShowHeight(): boolean {
      return this.isCollapsed
        ? !this.isAnimateStart || !this.isAnimateComplete
        : !this.isAnimateComplete
    },
    isHiddenContent(): boolean {
      return (
        this.isDynamicDrawContent && this.isCollapsed && this.isAnimateComplete
      )
    },
    collapseHeight(): number {
      const element: Element = this.$refs.collapseElement as Element
      const scrollHeight = element ? element.scrollHeight : 0
      return this.isCollapsed && this.isAnimateStart ? 0 : scrollHeight
    },
  },
})
